import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import SignIn from "views/auth/SignIn";
import { useDispatch, useSelector } from "react-redux";
import { useAuthInitializer } from "hooks/useAuthInitializer";
import { getOrderStatus } from "store/orderSlice";
import FullScreenLoader from "components/fullScreenLoader";
import { isTokenValid } from "hooks/tokenUtils";
import { getUserRoleList } from "store/userSlice";
import { getContainerStatus } from "store/containerSlice";

const App = () => {
  const dispatch = useDispatch();
  useAuthInitializer();

  const { token, userLoading } = useSelector((state) => state.auth);
  const { orderStatusLoading } = useSelector((state) => state.orders);
  const { roleLoading, roleData } = useSelector((state) => state.users);
  const { containerStatusLoading } = useSelector((state) => state.containers);

  useEffect(() => {
    dispatch(getOrderStatus());
    dispatch(getContainerStatus());
    dispatch(getUserRoleList({ page: 1, limit: 100 }));
  }, [dispatch, token]);

  const isAuthenticated = token && isTokenValid(token);

  if (
    userLoading ||
    orderStatusLoading ||
    containerStatusLoading ||
    roleLoading
  ) {
    return <FullScreenLoader />;
  }

  return (
    <Routes>
      {/* Auth Routes */}
      <Route
        path="/sign-in"
        element={
          <AuthLayout>
            <SignIn />
          </AuthLayout>
        }
      />

      {/* Admin Routes */}
      {isAuthenticated && <Route path="/*" element={<AdminLayout />} />}

      {/* Default redirect */}
      {isAuthenticated ? (
        <Route path="/*" element={<Navigate to="/dashboard" replace />} />
      ) : (
        <Route path="/*" element={<Navigate to="/sign-in" replace />} />
      )}
    </Routes>
  );
};

export default App;
